<template>
  <a :href="value.href" :target="value.target || '_blank'">{{ value.text }}</a>
</template>

<script>
export default {
  name: "LinkCell",
  props: {
    value: {},
  }
}
</script>

<style scoped>

</style>
